import { Component, OnInit } from '@angular/core';
import { RouteTypeService } from '../services/route-type.service';

@Component({
  selector: 'cert-voucher-info-banner',
  standalone: false,
  templateUrl: './voucher-info-banner.component.html',
})
export class VoucherInfoBannerComponent implements OnInit {
  portalSegment!: string;

  constructor(private readonly routeTypeService: RouteTypeService) {}

  ngOnInit() {
    this.portalSegment = this.routeTypeService.getPortalSegment().toLocaleUpperCase();
  }
}
